module.exports = __webpack_public_path__ + "static/media/ico_simulation_eye_eyebag.8182ae0f.png";